/* eslint-disable prettier/prettier */
export default {
	// 施設一覧API
	'EAPI00000001': 'You are not authorized.',
	'EAPI00100001': 'An unexpected error has occurred. Issues with property data acquisition.',
	'SAPI00100001': 'No data found',
	'SAPI00100002': 'Property list was obtained.',
	// 施設詳細API
	'EAPI00200001': 'You are not authorized.',
	'EAPI00200002': 'An unexpected error has occurred. Issues with property data acquisition.',
	'SAPI00200001': 'Property details were obtained.',
	// 施設更新API
	'EAPI03000001': 'Two or more addresses exist. Please contact your system administrator.',
	'EAPI03000002': 'Couldn\'t find the address. Please contact your system administrator.',
	'EAPI03000003': 'Two or more addresses exist. Please contact your system administrator.',
	'EAPI03000005': 'An unexpected error has occurred. Issues with property data update.',
	'SAPI00300001': 'Property Data Update Completed',
	// 施設登録API
	'EAPI03000006': 'An unexpected error has occurred. Issues with property data registration.',
	'SAPI00300002': 'Property data was registered.',
	// 施設削除API
	'EAPI00400001': 'An unexpected error has occurred. Issues with property data erasure.',
	'SAPI00400001': 'Property data was deleted.',
	// 店舗一覧API
	'EAPI00000003': 'This property has not been registered. ',
	'EAPI00000004': 'This request form cannot be accepted.',
	'EAPI01100001': 'An unexpected error has occurred. Issues with property data acquisition.',
	'SAPI01100001': 'No data found',
	'SAPI01100002': 'Store data was obtained.',
	// 店舗詳細API
	'EAPI00000002': 'This property has not been registered. ',
	'EAPI01200001': 'An unexpected error has occurred. Issues with property data update.',
	'SAPI01200001': 'Store details were obtained.',
	// 店舗更新API
	'EAPI01300001': 'Two or more addresses of the sub-account holder exist. Please contact your system administrator.',
	'EAPI01300002': 'An unexpected error has occurred. Issues with property data update.',
	'SAPI01300001': 'Store Data Update Completed',
	// 店舗削除API
	'EAPI01400001': 'An unexpected error has occurred. Issues with property data erasure.',
	'SAPI01400001': 'Store data was deleted.',
	// 管理店舗一覧API
	'EAPI01500001': 'An unexpected error has occurred. Issues with property management data acquisition.',
	'SAPI01500001': 'Store list on management data was obtained.',
	// 加入者店舗集計API
	'EAPI01600001': 'An unexpected error has occurred. Issues with acquisition of the number of registered stores.',
	'SAPI01600001': 'The number of registered stores was obtained.',
	// 店舗確認一覧API
	'EAPI02100001': 'An unexpected error has occurred. Issues with property confirmation data acquisition.',
	'SAPI02100001': 'No data found',
	'SAPI02100002': 'Store list was obtained.',
	// 店舗確認登録API
	'EAPI02300001': 'You are not authorized as the administrator of the registered property.',
	'EAPI02300004': 'You are not authorized.',
	'EAPI02300002': 'Two or more addresses exist. Please contact your system administrator.',
	'EAPI02300003': 'An unexpected error has occurred. Issues with property data registration.',
	'SAPI02300001': 'The user data has not been registered. ',
	// 画像一覧取得API
	'EAPI03100001': 'An unexpected error has occurred. Issues with image data acquisition.',
	'SAPI03100001': 'Image list was obtained.',
	// 画像アップロードAPI
	'EAPI03200001': 'The image exceeds the size limit.',
	'EAPI03200002': 'The image file exceeds the size limit.',
	'EAPI03200003': 'An unexpected error has occurred. Issues with image upload.',
	'SAPI03200001': 'The store image was uploaded.',
	// 画像削除API
	'EAPI03300001': 'An unexpected error has occurred. Issues with image modification(scheduled delete).',
	'SAPI03300001': 'The store image is to be deleted.',
	// ユーザー一覧API
	'EAPI00000006': 'An unexpected error has occurred. Issues with user data acquisition.',
	'SAPI00000001': 'User data was obtained.',
	// ユーザー更新API
	'EAPI04200001': 'Couldn\'t update. This email address is already registered.',
	'EAPI04200002': 'An unexpected error has occurred. Issues with user data update.',
	'SAPI04200001': 'User Data Update Completed',
	// ユーザー登録API
	'EAPI04200003': 'Couldn\'t register. This email address is already registered.',
	'EAPI04200004': 'An unexpected error has occurred. Issues with user data registration.',
	'SAPI04200002': 'Registration Successful',
	// ユーザー削除API
	'EAPI04300001': 'You are not authorized to use this function.',
	'EAPI04300002': 'An unexpected error has occurred. Issues with user data erasure.',
	'SAPI04300001': 'User data was deleted.',
	// ユーザー権限取得API
	'EAPI04400001': 'An unexpected error has occurred. Issues with user authority settings.',
	'SAPI04400001': 'You are now authorized.',
	// ユーザー詳細API
	'EAPI04500001': 'An unexpected error has occurred. Issues with user data detail acquisition.',
	'SAPI04500001': 'User details were obtained.',
	// センサ紐づけ登録API（解除）
	'EAPI05100001': 'The main sensor cannot be deleted. Change the main sensor to another sensor and then try delete it again.',
	'EAPI05100002': 'An unexpected error has occurred. Issues with deselecting connected sensors.',
	'SAPI05100001': 'The connected sensors were deselected.',
	// センサ紐づけ登録API（登録）
	'EAPI05100003': 'Failed to connect the sensor. Click "Registration" button on the sensor.',
	'EAPI05100004': 'The sensor is already registered as a main. Try registration again after deregistration.',
	'EAPI05100005': 'Registering sensors is needed first.',
	'EAPI05100006': 'An unexpected error has occurred. Issues with connecting sensor.',
	'EAPI05100007': 'This sensor failed to connect. It has already been connected to other stores, schools, and hospitals.',
	'SAPI05100002': 'The sensor was connected successfully.',
	'SAPI05100003': 'The sensor is forcibly connected to the room by special authority. Please be sure to check the linkage.',
	// センサ公開設定API
	'EAPI05200001': 'Main sensor can be set only for Store/Restaurant, School, Hospital.',
	'EAPI05200002': 'Select a main sensor from open sensors.',
	'EAPI05200003': 'The main sensor cannot be private. Set it as public.',
	'EAPI05200004': 'Tray again after releasing the main sensor.',
	'EAPI05200005': 'The main sensor cannot be unset.',
	'EAPI05200006': 'This request form cannot be accepted.',
	'EAPI05200007': 'An unexpected error has occurred. Issues with releasing sensor.',
	'SAPI05200001': 'Sensor Public Settings was completed.',
	// センサー一覧取得API
	'EAPI05300001': 'An unexpected error has occurred. Issues with sensor list acquisition.',
	'SAPI05300001': 'No data found',
	'SAPI05300002': 'Sensor list was obtained.',
	// センサー詳細取得API
	'EAPI05400001': 'This property is not registered. ',
	'EAPI05400002': 'An unexpected error has occurred. Issues with sensor detail acquisition.',
	'SAPI05400001': 'Couldn\'t get the data.',
	'SAPI05400002': 'Sensor details were obtained.',
	// センサー計測情報取得API
	'EAPI05500001': 'An unexpected error has occurred. Issues with sensor measured data acquisition.',
	'SAPI05500001': 'Sensor measured data was obtained.',
	'SAPI05500002': 'No IoT data found.',
	// センサー設定情報取得API
	'EAPI05600001': 'You are not authorized.',
	'EAPI05600002': 'An unexpected error has occurred. Issues with sensor setting data acquisition.',
	'SAPI05600001': 'Failed to obtain sensor setting data.',
	'SAPI05600002': 'Sensor settings data was obtained.',
	// 店舗センサー一覧取得API
	'EAPI05700001': 'An unexpected error has occurred. Issues with connected sensor list acquisition.',
	'SAPI05700001': 'Failed to obtain sensor list.',
	'SAPI05700002': 'Connected sensor list was obtained.',
	// 部屋情報削除API
	'EAPI06200001': 'An unexpected error has occurred. Issues with room data erasure.',
	'SAPI06200001': 'Couldn\'t find the target data.',
	'SAPI06200002': 'Room data was deleted.',
	// 店舗部屋一覧取得API
	'EAPI06300001': 'An unexpected error has occurred. Issues with room list acquisition.',
	'SAPI06300001': 'No manageable rooms available',
	'SAPI06300002': 'Room list was obtained.',
	// セキュリティ詳細取得API
	'EAPI07100001': 'An unexpected error has occurred. Issues with security data acquisition.',
	'SAPI07100001': 'Security data was obtained.',
	// セキュリティ更新API
	'EAPI07200001': 'An unexpected error has occurred. Issues with security data update.',
	'SAPI07200001': 'Security Data Update Completed',
	// お知らせ一覧取得API
	'EAPI08100001': 'An unexpected error has occurred. Issues with alert data acquisition.',
	'SAPI08100001': 'Alert data was obtained.',
	// お知らせ詳細情報取得API
	'EAPI08200001': 'No data found',
	'EAPI08200002': 'An unexpected error has occurred. Issues with alert data acquisition.',
	'SAPI08200001': 'Alert details were obtained.',
	// お知らせ情報登録API
	'EAPI08300001': 'An unexpected error has occurred. Issues with alert data registration.',
	'SAPI08300001': 'Alert data was registered.',
	// お知らせ情報更新API
	'EAPI08300002': 'No data found',
	'EAPI08300003': 'An unexpected error has occurred. Issues with alert data update.',
	'SAPI08300002': 'Alert Data Update Completed',
	// お知らせ情報削除API
	'EAPI08400001': 'No data found',
	'EAPI08400002': 'An unexpected error has occurred. Issues with alert data erasure.',
	'SAPI08400001': 'Alert data was deleted.',
	// ダウンロード一覧取得API
	'EAPI10100001': 'An unexpected error has occurred. Issues with download information acquisition.',
	'SAPI10100001': 'No data found',
	'SAPI10100002': 'Download data was obtained.',
	// センサーデータダウンロードAPI
	'EAPI10200001': 'Sensor data is not available for download.',
	'EAPI10200002': 'An unexpected error has occurred. Issues with downloading sensor data.',
	'SAPI10200001': 'presigned-URL was obtained.',
	// センサデータ出力API
	'EAPI10300001': 'Select the output period to be in the past.',
	'EAPI10300002': 'An unexpected error has occurred. Issues with download information registration.',
	'SAPI10300001': 'Download data was registered.',
	// ダウンロード情報削除API
	'EAPI10400001': 'An unexpected error has occurred. Issues with sensor data erasure.',
	'SAPI10400001': 'Download data was deleted.',
	// セキュリティユーザー一覧取得API
	'EAPI11100001': 'This property is not registered. ',
	'EAPI11100002': 'An unexpected error has occurred. Issues with security user data list acquisition.',
	'SAPI11100001': 'No data found.',
	'SAPI11100002': 'Security user list was obtained.',
	// セキュリティユーザー情報削除API
	'EAPI11200001': 'Incorrect; Try Again; Delete mode',
	'EAPI11200002': 'An unexpected error has occurred. Issues with security data erasure.',
	'SAPI11200001': 'Security user was deleted.',
	// 埋め込みHTML設定情報一覧API
	'EAPI12100001': 'An unexpected error has occurred. Issues with embedded HTML setting data acquisition.',
	'SAPI12100001': 'Embedded HTML setting data list was obtained.',
	// 埋め込みHTML設定情報取得API
	'EAPI12200001': 'No data found',
	'EAPI12200002': 'An unexpected error has occurred. Issues with embedded HTML setting data acquisition.',
	'SAPI12200001': 'Embedded HTML setting data was obtained.',
	// 埋め込みHTML設定情報更新API
	'EAPI00000005': 'No data found.',
	'EAPI12300001': 'Incorrect; Try Again; The number of selected sensors',
	'EAPI12300002': 'Incorrect; Try Again; The number of view items',
	'EAPI12300003': 'Incorrect; Try Again; Value of the view type',
	'EAPI12300004': 'Incorrect; Try Again; Value of the view color',
	'EAPI12300005': 'You are not authorized.',
	'EAPI12300007': 'An unexpected error has occurred. Issues with embedded HTML setting data acquisition.',
	'SAPI12300001': 'Embedded HTML setting data Update Completed',
	// 埋め込みHTML設定情報登録API
	'EAPI12300006': 'You are not authorized to use this function.',
	'EAPI12300008': 'An unexpected error has occurred. Issues with embedded HTML setting data registration.',
	'SAPI12300002': '',
	// 埋め込みHTML設定情報削除API
	'EAPI12400001': 'You are not authorized.',
	'EAPI12400002': 'An unexpected error has occurred. Issues with embedded HTML setting data erasure.',
	'SAPI12400001': 'Embedded HTML setting data acquisition was deleted.',
	// アンケート回答年月取得API
	'EAPI14200001': 'Property ID of required parameter and area ID are not included in the list.',
	'EAPI14200002': 'The property ID type is not integer type.',
	'EAPI14200003': 'The area ID type is not integer type.',
	'EAPI14200004': 'An unexpected error has occurred. Issues with survey response date and time acquisition.',
	'SAPI14200001': 'Survey response date and time was obtained.',
	'SAPI14200002': 'No data found',
	// アンケート結果ダウンロード情報取得API
	'EAPI14300001': 'An unexpected error has occurred. Issues with downloaded survey data acquisition.',
	'SAPI14300001': 'No data found',
	'SAPI14300002': 'Downloaded survey data was obtained.',
	// アンケート結果ダウンロードAPI
	'EAPI14400001': 'Survey results are not available for download.',
	'EAPI14400002': 'An unexpected error has occurred. Issues with presigned-URL for ZIP file of survey results acquisition.',
	'SAPI14400001': 'presigned-URL for ZIP file of survey results was obtained.',
	// アンケート結果出力API
	'EAPI14500001': 'An unexpected error has occurred. Issues with survey results acquisition.',
	'SAPI14500001': 'Survey result output was registered.',
	// アンケート結果ダウンロード削除API
	'EAPI14600001': 'An unexpected error has occurred. Issues with deleting survey results.',
	'SAPI14600001': 'Survey result data was deleted.',
	// 施設向けレポートダウンロードAPI
	'SAPI15100002': 'No file found',
	'SAPI15100001': 'presigned-URL was obtained.',
	'EAPI15100001': 'An unexpected error has occurred. Issues with downloading Group Report.',
	// 店舗向けレポートダウンロードAPI
	'SAPI15200001': 'presigned-URL was obtained.',
	'EAPI15200001': 'An unexpected error has occurred. Issues with downloading Report.',
	// 店舗向けレポート一括ダウンロードAPI
	'SAPI15300001': 'presigned-URL was obtained.',
	'EAPI15300001': 'An unexpected error has occurred. Issues with downloading Report Batch.',

	// リセラー管理
	'EAPI16100001': 'An error occurred while getting the reseller list.',
	'SAPI16100001': 'Acquisition of the reseller list completed.',
	'SAPI16100002': 'No reseller found.',
	'EAPI16200001': 'An error occurred while getting reseller details.',
	'EAPI16200002': 'The target reseller information does not exist or cannot be displayed at the selected reseller.',
	'EAPI16200003': 'You are not authorized.',
	'SAPI16200001': 'No reseller found.',
	'SAPI16200002': 'Acquisition of reseller details completed.',
	'EAPI16300001': 'Registration failed. You are alredy registered as a reseller administrator.',
	'EAPI16300002': 'Two or more email addresses for administrator are registered as the reseller administrator information. Please contact your system administrator.',
	'EAPI16300003': 'The same email address has been set for multiple reseller administrators.',
	'EAPI16300007': 'An error occurred wile registrating reseller.',
	'EAPI16300004': 'An error occurred wile updaing reseller.',
	'EAPI16300005': 'You are not authorized.',
	'EAPI16300006': 'No reseller found.',
	'SAPI16300001': 'Reseller registration completed.',
	'SAPI16300002': 'Reseller update completed.',
	'EAPI16400001': 'Delete failed since managed reseller information remains.',
	'EAPI16400002': 'Delete failed since managed facility information remains.',
	'EAPI16400003': 'No reseller found.',
	'EAPI16400004': 'An error occurred while deleting a reseller.',
	'SAPI16400001': 'Reseller deleted',

	// リセラー情報取得ファンクション
	'EAPI00000007': 'An error occurred while retrieving reseller information',

}
